import React, { useState } from 'react';
import {
  TextField, Grid, MenuItem, FormHelperText,
  InputAdornment, IconButton
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

/**
 * Shared User form fields — used by both Add and Edit.
 * isEdit=true makes password fields optional.
 */
const UserForm = ({ formData, errors, roles, handleNameChange, handleChange, handleBlur, isEdit = false }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField label={<span>Username <span style={{ color: 'red' }}>*</span></span>} name="username" value={formData.username} onChange={handleNameChange} onBlur={handleBlur} fullWidth error={!!errors.username} helperText={errors.username || ' '} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField label={<span>Full Name <span style={{ color: 'red' }}>*</span></span>} name="fullname" value={formData.fullname} onChange={handleNameChange} onBlur={handleBlur} fullWidth error={!!errors.fullname} helperText={errors.fullname || ' '} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField label={<span>Email <span style={{ color: 'red' }}>*</span></span>} name="email" type="email" value={formData.email} onChange={handleChange} onBlur={handleBlur} fullWidth error={!!errors.email} helperText={errors.email || ' '} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField label={<span>Role <span style={{ color: 'red' }}>*</span></span>} name="role" value={formData.role} onChange={handleChange} onBlur={handleBlur} select fullWidth error={!!errors.role} helperText={errors.role || ' '}>
          {(roles || []).map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label={isEdit ? 'Password (leave blank to keep current)' : <span>Password <span style={{ color: 'red' }}>*</span></span>}
          name="password" type={showPassword ? 'text' : 'password'} value={formData.password}
          onChange={handleChange} onBlur={handleBlur} fullWidth error={!!errors.password} helperText={errors.password || ' '}
          InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowPassword(p => !p)} edge="end">{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment>) }}
        />
        {!errors.password && formData.password && <FormHelperText>Min 8 chars with uppercase, lowercase and numbers</FormHelperText>}
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label={isEdit ? 'Confirm Password' : <span>Confirm Password <span style={{ color: 'red' }}>*</span></span>}
          name="confirmPassword" type={showConfirmPassword ? 'text' : 'password'} value={formData.confirmPassword}
          onChange={handleChange} onBlur={handleBlur} fullWidth error={!!errors.confirmPassword} helperText={errors.confirmPassword || ' '}
          InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowConfirmPassword(p => !p)} edge="end">{showConfirmPassword ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment>) }}
        />
      </Grid>
    </Grid>
  );
};

export default UserForm;
